import { createStore } from 'vuex';
import * as modules from './modules';
import { i18n, api, router } from '../config';
import { persistence, sessionPersistence } from './plugins';
import services from '../data/services.yml';

export default createStore({
  modules,
  plugins: [
    persistence.plugin,
    sessionPersistence.plugin,
  ],
  getters: {
    services: () => services.items,
    locale: () => i18n.global.locale.value,
    i18n: () => i18n,
    tm: () => (key) => i18n.global.tm(key),
    router: () => router,
    api(state, getters) {
      const { token } = state.session;

      Object.assign(api.defaults.headers.common, {
        Authorization: token,
        'X-Language': getters.locale,
      });

      return api;
    },
  },
});
